import api from "./api";

export const getSystemInfo = async () => {
  const { data } = await api.get("/system/info");
  return data;
};

export const getBillingFeatureState = async () => {
  const { data } = await api.get("/billing/pilot/feature-state");
  return data;
};

export const getBillingPilotDashboard = async () => {
  const { data } = await api.get("/billing/pilot/dashboard");
  return data;
};
